import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-04-10T11:53:38-0700.
 */
export function useWorkOrderDownloadServiceRequestEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.WorkOrdersPDF, false);

  return Boolean(isEnabled);
}
